var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dialogComponents-container" }, [
    _c(
      "div",
      [
        _c(
          "el-dialog",
          {
            staticClass: "dialog-dialog",
            attrs: {
              title: "系統通知",
              visible: _vm.innerDialogVisible,
              "append-to-body": "",
              "close-on-click-modal": false,
              "destroy-on-close": true,
              "show-close": false,
              width: _vm.device == "mobile" ? "90%" : "60%",
            },
            on: {
              closed: function ($event) {
                return _vm.setDialog(false)
              },
              "update:visible": function ($event) {
                _vm.innerDialogVisible = $event
              },
            },
          },
          [
            _c(
              "div",
              [
                _c("el-alert", {
                  staticStyle: {
                    "background-color": "#ffd643",
                    color: "#4b4b4b",
                  },
                  attrs: {
                    title: _vm.content,
                    type: "info",
                    effect: "dark",
                    "show-icon": "",
                    closable: false,
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer",
              },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "danger" },
                    on: {
                      click: function ($event) {
                        return _vm.setDialog(false)
                      },
                    },
                  },
                  [_vm._v("關 閉")]
                ),
              ],
              1
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }